import { render, staticRenderFns } from "./cardperformance.vue?vue&type=template&id=afa2bf60&scoped=true&"
import script from "./cardperformance.vue?vue&type=script&lang=js&"
export * from "./cardperformance.vue?vue&type=script&lang=js&"
import style0 from "./cardperformance.vue?vue&type=style&index=0&id=afa2bf60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa2bf60",
  null
  
)

export default component.exports